<div class="aarni-font relative block mt-[80px]">
    <picture>
        <source media="(min-width:1024px)"
                srcset="assets/img/school-desktop-banners/arni-school-of-paramedical-large-screen.webp">
        <source media="(min-width:768px)"
                srcset="assets/img/school-desktop-banners/medium-screen/arni-school-of-paramedical-medium-screen.webp">
        <img
            src="assets/img/mobile-banners-schools/arni-school-of-paramedical-mobile-view.webp"
            alt="Faculty Banner"
            class="w-full h-auto"
        >
    </picture>
</div>

<section class="aarni-font py-12">
    <div class="container mx-auto p-4">
        <div
            class="md:flex flex-wrap hidden space-x-4 p-6 xl:p-4 mb-4 border-2 border-gray-200 rounded-full gap-y-3 mx-auto xl:justify-center">
            <a href="#overview"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400  active-tab">Overview</a>
            <a href="#courses"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">Courses</a>
            <a href="#specialisation"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">Specialization</a>
            <a href="#hod-message"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">HOD's
                Message</a>
            <a href="#whats-happening"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">What's
                Happening</a>
            <a href="#expert-faculty"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">Expert
                Faculty</a>
           <!-- <a href="#testimonials"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">Testimonials</a>-->
            <a href="#gallery"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">Gallery</a>
            <a href="#recruiters"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">Recruiters</a>
        </div>

        <div id="overview" class="section p-4">
            <h2 class="text-3xl font-bold mb-2">Arni School of Allied Health Sciences</h2>
            <h2 class="text-xl font-bold mb-2">Overview</h2>
            <p class="text-gray-500 text-justify">The ARNI School of Allied Health Sciences provides a dynamic learning
                environment that merges theoretical knowledge with practical skills to train students for the healthcare
                industry. We believe that the doctors are not only contributors to the healthcare industry – it is a
                collaborative system where allied health professionals play an important role in treatment, diagnosis,
                and patient care.
            </p>
            <p class="text-gray-500 text-justify">The school is dedicated to preparing skilled professionals who are
                compassionate and enthusiastic to serve medical facilities, handling treatment, illness prevention, and
                diagnosis. Our programs aiming allied health science are built to meet the growing demand for trained
                professionals in fields such as medical lab technology, radiology, physiotherapy, emergency care,
                optometry, and more.
            </p>
            <p class="text-gray-500 text-justify">At ARNI University, we are focused on making our students
                future-ready, not just job-ready. Our curriculum integrates evidence-based learning, ethics, and the
                latest technologies, ensuring students' holistic development. We equip students with relevant skills and
                expertise by emphasizing rigorous academic learning and practical exposure, followed by industry experts
                and mentors.
            </p>
            <p class="text-gray-500 text-justify my-2"><strong>Vision -</strong> We envision training competent and
                knowledgeable healthcare professionals who contribute meaningfully to the well-being of society. We want
                to be the leading name in the allied health science sector for producing eligible professionals.
            </p>
            <p class="text-gray-500 text-justify my-2"><strong>Mission -</strong> Our mission is to provide a strong
                focus on ethical practice, hands-on experience, and critical thinking, healthcare professionals who are
                not just proficient with their business but also empathetic towards their patients.</p>
        </div>

        <div id="courses" class="section px-4">
            <h2 class="text-xl font-bold mb-2">Courses</h2>
            <p class="text-gray-500 text-justify">The ARNI School of Allied Health Sciences offers undergraduate and
                diploma programs that cater to the growing demand for trained healthcare professionals. Our university
                takes pleasure in providing a wide variety of allied health science courses in six vibrant departments,
                each specifically designed to address the changing needs of the healthcare sector. We provide students
                with a comprehensive educational experience that combines academic knowledge with real-world
                application, all while fostering the development of knowledgeable and caring professionals.
            </p>
            <p class="text-gray-500 text-justify">Our committed instructors and advanced facilities guarantee that
                students will obtain the best education possible, regardless of their career goals—whether they are in
                medical imaging, medical laboratory sciences, rehabilitation treatments, surgical aid, or vision care.
                Our demanding curriculum is intended to provide you with the know-how and abilities you need to succeed
                in your chosen sector and significantly improve the health and well-being of both individuals and
                communities.
            </p>
            <!--<ul class="list-disc">
                <li class="text-gray-500 text-justify my-2">
                    Undergraduate Programs
                    <ul class="list-disc ml-6">
                        <li>B.Sc Medical Radiology & Imaging Technology</li>
                        <li>B.Sc. Operation Theatre Technology</li>
                        <li>B.Sc Anaesthesia Technology</li>
                        <li>B.Sc. Medical Lab Technology</li>
                        <li>Bachelor of Physiotherapy</li>
                        <li>B.Sc. Optometry</li>
                    </ul>
                </li>
                <li class="text-gray-500 text-justify my-2">
                    Diploma Programs
                    <ul class="list-disc ml-6">
                        <li>Diploma In Medical Lab Technology (MLT)</li>
                        <li>Diploma In Cardiac Care Technology</li>
                        <li>Diploma In Multipurpose Health Worker</li>
                        <li>Diploma In Dialysis Technology</li>
                        <li>Diploma In Anaesthesia Technology</li>
                        <li>Diploma In Operation Theatre Technology</li>
                        <li>Diploma In Physiotherapy</li>
                        <li>Diploma In Radiology & Imaging Technology</li>
                        <li>Diploma In Optometry</li>
                    </ul>
                </li>
            </ul>-->
            <p class="text-gray-500 text-justify"><strong>Scope:</strong> The health care management degree program
                offers a comprehensive education in various disciplines, including Radiology, Medical Laboratory
                Technology, Physiotherapy, Anesthesia Technology, Operation Theater Technology, and
                Optometry and Forensic Sciences.
            </p>
            <ul class="list-disc px-5">
                <li class="text-gray-500 text-justify my-2">These programs equip students with diverse skills for the
                    healthcare industry, preparing them for various roles such as diagnosis, treatment planning, patient
                    rehabilitation, and surgical equipment management.
                </li>
                <li class="text-gray-500 text-justify my-2">Vast Career Opportunities in hospitals, diagnostic labs,
                    research institutions, rehabilitation centers, and community health organizations.
                </li>
                <li class="text-gray-500 text-justify my-2">Active involvement in research projects addressing critical
                    health issues and developing innovative solutions.
                </li>
                <li class="text-gray-500 text-justify my-2">Trained students can work in emergency rooms, ambulances, or
                    trauma centers, delivering immediate care in life-threatening situations.
                </li>
                <li class="text-gray-500 text-justify my-2">Allied health graduates can work with the government and
                    NGOs in disease prevention, awareness campaigns, and community health education.
                </li>
                <li class="text-gray-500 text-justify my-2">The degree opens doors to master's programs, global
                    healthcare certifications, and specializations that can lead to international opportunities.
                </li>
            </ul>
            <p class="text-gray-500 text-justify">Whether your goal is to serve people, explore vast career
                opportunities, or improve the healthcare industry. Our course will work as the foundation of your
                dreams. Join us in shaping a healthier tomorrow.
            </p>
            <h4 class="text-xl font-bold mb-2">Career Opportunities</h4>
            <ul class="list-disc px-5">
                <li class="text-gray-500 my-2"><span class="font-semibold">Medical Laboratory Technologist -</span>
                    Degree/certificate holders can work in hospitals, private or government labs, and diagnostic centers
                    as lab technologists who perform clinical tests for diagnosis and treatment planning.
                </li>
                <li class="text-gray-500 my-2"><span class="font-semibold">Radiologic Technologist -</span> Produce and
                    interpret medical images using CT scans, MRIs, X-rays, and other imaging technologies, collaborate
                    with radiologists in identifying abnormalities and injuries.
                </li>
                <li class="text-gray-500 my-2"><span
                    class="font-semibold">Physiotherapist / Rehabilitation Specialist -</span> Work in hospitals, sports
                    facilities, and clinics as a physiotherapist or rehabilitation specialist to help patients regain
                    their function and strength.
                </li>
                <li class="text-gray-500 my-2"><span class="font-semibold">Operation Theatre Assistant -</span>
                    Administer the operation theatre, manage and prepare the surgical equipment, update inventory, and
                    assist surgeons during complex procedures.
                </li>
                <li class="text-gray-500 my-2"><span class="font-semibold">Emergency Medical Technician (EMT) -</span>
                    Deliver pre-hospital care during emergencies, making split-second decisions that save lives.
                </li>
            </ul>

            <h2 class="text-xl font-bold mb-2">Arni University’s Contribution to Emerging Technologies</h2>
            <p class="text-gray-500 my-2">At ARNI University, we are proud to play a role in educating the healthcare
                professionals of the future, through our School of Allied Health Sciences. We contribute to the
                healthcare ecosystem by developing a robust learning environment that creates academic and practical
                competency in each student. Our campus is equipped with modern laboratories, simulation centers, and
                clinical partnerships with established hospitals to provide authentic, clinical exposure to students.
            </p>
            <p class="text-gray-500 my-2">We focus on skill-based and experiential learning, enhancing the medical
                content with emphasis on communication, empathy, and teamwork. Beyond class study, students experience
                the clinical environment through regular clinical postings, hospital visits, internships, and live
                projects, which prepare confident graduates for real-world medical practice.
            </p>
            <p class="text-gray-500 my-2">Our faculty are practitioners, researchers and industry mentors who lead
                students in a way that ensures the most current knowledge, ethics, and career advice. In addition, we
                focus on holistic development that nurtures the individual passion and thought through seminars,
                workshops, certifications and career advice.
            </p>
            <p class="text-gray-500 my-2">In addition to developing passionate and capable healthcare professionals, the
                School of Allied Health Sciences at ARNI University promotes research, innovation, and a service mindset
                that positively contributes to a healthier society and a stronger healthcare workforce to tackle health
                challenges both nationally and internationally.
            </p>

            <h2 class="text-xl font-bold mb-2">Why Choose ARNI?</h2>
            <ul class="list-disc px-5">
                <li class="text-gray-500 my-2">We update our syllabus frequently with industry-relevant topics and
                    contemporary learnings that reflect new advancements in healthcare to meet global medical standards.
                </li>
                <li class="text-gray-500 my-2">We have modern labs and clinical facilities to train students with the
                    latest technologies, preparing them for hospital-grade operations and emergencies.
                </li>
                <li class="text-gray-500 my-2">We have collaborated with industry giants and leading hospitals to
                    provide placement and internship support to the students, empowering employment opportunities.
                </li>
                <li class="text-gray-500 my-2">Students will have the chance to learn from the industry experts,
                    including doctors, technologists, and physiotherapists who bring real-world insights into the
                    classroom.
                </li>
                <li class="text-gray-500 my-2">We believe in students’ holistic development, encourage learning beyond
                    traditional boundaries. We offer co-curricular activities, leadership programs, and soft skill
                    training sessions.
                </li>
                <li class="text-gray-500 my-2">We believe in making quality healthcare education accessible through
                    merit-based scholarships and flexible payment options.
                </li>
            </ul>

            <p class="my-2 text-gray-500 font-semibold">Whether your goal is to serve people, explore vast career
                opportunities, or improve the healthcare industry. Our course will work as the foundation of your
                dreams. Join us in shaping a healthier tomorrow.
            </p>
        </div>
    </div>
    <div id="specialisation" class="w-full bg-gray-100">
        <div class="max-w-7xl mx-auto p-6">
            <h2 class="text-2xl font-bold text-center mb-8 text-gray-800">Allied Health Sciences Disciplines &
                Specializations</h2>
            <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                <div
                    *ngFor="let department of departments"
                    class="bg-white p-5 rounded-2xl shadow-md border border-gray-200 hover:shadow-lg transition-shadow duration-300"
                >
                    <div class="flex items-center mb-4">
                        <i class="fa" [ngClass]="department.icon + ' text-2xl text-blue-600 mr-3'"></i>
                        <span class="text-xl font-semibold text-gray-800">{{ department.name }}</span>
                    </div>
                    <div class="max-h-40 overflow-y-auto custom-scrollbar pr-2">
                        <ul class="list-disc pl-6 text-sm text-gray-700 space-y-1">
                            <li *ngFor="let branch of department.branches">{{ branch }}</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div class="bg-gradient-to-b from-indigo-500 to-blue-400 text-white py-8  text-center mt-6">
            <div class="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 py-8">
                <div>
                    <p class="text-3xl font-bold">200+</p>
                    <p class="text-lg">Programs</p>
                </div>
                <div>
                    <p class="text-3xl font-bold">500+</p>
                    <p class="text-lg">Faculties</p>
                </div>
                <div>
                    <p class="text-3xl font-bold">11000+</p>
                    <p class="text-lg">Students</p>
                </div>
                <div>
                    <p class="text-3xl font-bold">120+</p>
                    <p class="text-lg">Acre of campus</p>
                </div>
            </div>
        </div>
    </div>
    <div class="w-full">
        <div id="hod-message"
             class="max-w-6xl mx-auto bg-white shadow-lg rounded-lg flex flex-col md:flex-row overflow-hidden my-8 p-4">
            <div class="relative w-full md:w-1/3">
                <img
                    src="assets/img/dean-as-per-schools/dr-tahseen-bilal-rather-arni-school-of-allied-health-sciences.png"
                    alt="Dean" class="w-full h-full object-cover">
                <div class="absolute bottom-0 left-0 right-0 bg-blue-500 text-white text-center py-2">
                    Dr. Tahseen Bilal Rather
                </div>
            </div>
            <div class="w-full md:w-2/3 p-6 overflow-y-auto h-auto custom-scrollbar">
                <h2 class="text-2xl font-bold mb-2">HOD’s Message</h2>
                <p class="text-gray-700 text-justify">
                    I feel very honored to serve as the Dean of the ARNI School of Allied Health Science at ARNI
                    University. This is my great pleasure to welcome you all who are applying for undergraduate programs
                    (BMLT, BSc MRIT, BSc OTT, BSc optometry, Naturopathy & Yogic Sciences, and Bachelor of Science in Physiotherapy) and
                    the Diploma in Naturopathy & Yogic Sciences program.
                </p>
                <p class="text-gray-700 mt-4 text-justify">
                    We have designed our academic programs, practical, and other crucial activities as per the latest
                    industry trends and techniques under the guidance of well-qualified researchers and industry
                    experts. Thus, our students never felt lost, unconfident, or inept in the industry. We are not just
                    tutors, we are mentors, supporters, and the biggest fans of our students.
                </p>
                <p class="text-gray-700 mt-4 text-justify">
                    Additionally, it features a Placement Cell with 100% placement potential. All new students who are
                    thinking about enrolling at this university for the forthcoming academic year are cordially invited
                    to do so.
                </p>
                <p class="text-gray-700 mt-2 text-justify">
                    Sincerely,
                </p>
                <p class="text-gray-700 mt-2 text-justify font-bold">
                    Dr. Tahseen Bilal Rather
                </p>
                <p class="text-gray-700 mt-2 text-justify">
                    Dean, ARNI School of Allied Health Science
                </p>
                <p class="text-gray-700 mt-2 text-justify">
                    ARNI University
                </p>
            </div>
        </div>

        <div id="whats-happening" class="w-full">
            <div class="bg-gradient-to-b from-blue-500 to-blue-300 py-12">
                <div class="container mx-auto px-6">
                    <h2 class="text-white text-2xl font-bold text-center mb-6">WHAT’S HAPPENING IN SCHOOL</h2>
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        <div *ngFor="let event of events" class="bg-white rounded-lg shadow-lg overflow-hidden">
                            <img [src]="event.image" alt="Event Image" class="w-full h-56 object-cover">
                            <div class="p-4">
                                <span
                                    class="bg-blue-500 text-white text-xs font-bold px-3 py-1 rounded-full absolute -mt-8">Event</span>
                                <!--<p class="text-sm text-gray-600 font-bold mt-3">{{ event.date }}</p>-->
                                <h3 class="text-lg font-semibold mt-2">{{ event.title }}</h3>
                                <p class="text-sm text-gray-600 mt-2">{{ event.description }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="flex justify-center mt-10">
                        <a
                            href="/whats-happening/event-calendar"
                            class="py-3 px-8 rounded-full bg-white text-[#012E26] hover:bg-[#00BFA5] hover:text-white transition-all duration-300 font-medium shadow-md"
                        >
                            View More
                        </a>
                    </div>
                    <!--<div class="bg-white mt-12 p-6 rounded-lg shadow-lg">
                        <h3 class="font-bold text-lg mb-4">ANNOUNCEMENTS</h3>
                        <div class="flex flex-wrap md:flex-nowrap justify-center gap-4">
                            <div *ngFor="let announcement of announcements | slice:0:3"
                                 class="w-full md:w-1/3 bg-gray-100 p-4 rounded-lg flex items-center">
                                <div class="bg-green-500 text-white font-bold text-center px-4 py-2 rounded-md">
                                    <p class="text-sm">{{ announcement.date }}</p>
                                </div>
                                <p class="ml-4 text-sm text-gray-700">{{ announcement.text }}</p>
                            </div>
                        </div>
                    </div>-->
                </div>
            </div>
        </div>
        <div id="expert-faculty" class="w-full">
            <div class="relative w-full md:flex flex-col items-center bg-gray-100 py-8 hidden">
                <h2 class="text-2xl font-bold mb-6 text-center">Expert Faculty</h2>
                <div class="relative w-full max-w-6xl overflow-hidden">
                    <div
                        class="flex transition-transform duration-300 ease-in-out"
                        [ngStyle]="{ transform: 'translateX(' + translateX + '%)' }"
                    >
                        <div
                            *ngFor="let faculty of faculties"
                            class="flex-shrink-0 w-full sm:w-1/2 md:w-1/3 lg:w-1/4 p-4"
                        >
                            <div class="bg-white p-6 rounded-lg shadow-md flex flex-col items-center h-[350px]">
                                <div class="h-[140px] flex items-center justify-center">
                                    <img
                                        [src]="faculty.image"
                                        alt="faculty image"
                                        class="w-32 h-32 rounded-full border-4 border-white shadow-md"
                                    />
                                </div>
                                <div class="h-[140px] flex flex-col items-center justify-center text-center">
                                    <h3 class="mt-2 text-lg font-semibold">{{ faculty.name }}</h3>
                                    <p class="text-sm text-gray-600 flex items-center mt-2">{{ faculty.designation }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <button
                    (click)="prev()"
                    class="absolute left-2 top-1/2 transform -translate-y-1/2 bg-white p-2 rounded-full shadow-md hover:bg-gray-200"
                >
                    <i class="fa fa-chevron-left text-[#012E26]"></i>
                </button>
                <button
                    (click)="next()"
                    class="absolute right-2 top-1/2 transform -translate-y-1/2 bg-white p-2 rounded-full shadow-md hover:bg-gray-200"
                >
                    <i class="fa fa-chevron-right text-[#012E26]"></i>
                </button>
                <button class="mt-6 px-4 py-2 bg-blue-500 text-white rounded-full shadow-md"
                        (click)="goTo('/about/faculty')">
                    View All Faculty
                </button>
            </div>
            <div class="relative w-full sm:flex flex-col items-center bg-gray-100 py-8 md:hidden">
                <h2 class="text-2xl font-bold mb-6 text-center">Expert Faculty</h2>
                <div class="w-full">
                    <div
                        *ngFor="let faculty of faculties | slice:0:3"
                        class="flex flex-col items-center p-4"
                    >
                        <div class="bg-white p-6 rounded-lg shadow-md flex flex-col items-center h-[350px]">
                            <div class="h-[140px] flex items-center justify-center">
                                <img
                                    [src]="faculty.image"
                                    alt="faculty image"
                                    class="w-32 h-32 rounded-full border-4 border-white shadow-md"
                                />
                            </div>
                            <div class="h-[140px] flex flex-col items-center justify-center text-center">
                                <h3 class="mt-2 text-lg font-semibold">{{ faculty.name }}</h3>
                                <p class="text-sm text-gray-600 flex items-center mt-2">{{ faculty.designation }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex justify-center">
                    <button class="mt-6 px-4 py-2 bg-blue-500 text-white rounded-full shadow-md"
                            (click)="goTo('about/faculty')">
                        View All Faculty
                    </button>
                </div>
            </div>
        </div>

        <!--<div id="testimonials" class="py-16 bg-white aarni-font">
            <div class="container mx-auto px-4 text-center">
                <h2 class="text-4xl font-bold text-[#012E26] mb-12">Testimonials</h2>
                <div class="testimonial-slider relative">
                    <div class="overflow-hidden px-2">
                        <div
                            class="flex transition-transform duration-500 ease-in-out"
                            [ngStyle]="{
            transform: 'translateX(' + -testimonialSlideIndex * 100 + '%)'
          }"
                        >
                            <ng-container *ngFor="let group of groupedTestimonials">
                                <div class="w-full flex-shrink-0 flex pb-4">
                                    <div
                                        *ngFor="let testimonial of group"
                                        class="w-full md:1/2 lg:w-1/3 px-3"
                                    >
                                        <div
                                            class="bg-white rounded-lg shadow-lg overflow-hidden transition-all duration-300 hover:shadow-xl h-full">
                                            <div class="bg-[#ff6347] h-32 rounded-t-lg relative">
                                                <div
                                                    class="absolute left-1/2 transform -translate-x-1/2 bottom-0 translate-y-1/2"
                                                >
                                                    <div class="w-24 h-24 rounded-full bg-white p-1">
                                                        <img
                                                            [src]="testimonial.image"
                                                            [alt]="testimonial.name"
                                                            class="w-full h-full rounded-full object-cover"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="pt-16 pb-8 px-6">
                                                <h3
                                                    class="text-xl font-semibold text-center text-[#012E26] mb-2"
                                                >
                                                    {{ testimonial.name }}
                                                </h3>
                                                <div class="flex justify-center mb-4">
                                                    <i
                                                        class="fa fa-star text-yellow-400"
                                                        *ngFor="let star of [1, 2, 3, 4, 5]"
                                                    ></i>
                                                </div>
                                                <p class="text-gray-700 text-center mb-6">
                                                    {{ testimonial.feedback }}
                                                </p>
                                                <div class="text-center text-sm text-gray-600">
                                                    <p class="font-semibold">{{ testimonial.course }}</p>
                                                    &lt;!&ndash;  <p class="font-bold text-[#012E26]">
                                                          Placed In:
                                                          <span class="text-[#00BFA5]">
                            {{ testimonial.company }}
                          </span>
                                                      </p>&ndash;&gt;
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>

                    &lt;!&ndash; Pagination Dots &ndash;&gt;
                    <div class="flex justify-center mt-8 space-x-2">
                        <button
                            *ngFor="let group of groupedTestimonials; let i = index"
                            [ngClass]="{
            'bg-[#00BFA5]': testimonialSlideIndex === i,
            'bg-gray-300': testimonialSlideIndex !== i
          }"
                            class="w-3 h-3 rounded-full transition-all duration-300"
                            (click)="setTestimonialSlide(i)"
                        ></button>
                    </div>
                </div>

                <div class="flex justify-center mt-10">
                    <a
                        href="/quick-links/student-testimonial"
                        class="py-3 px-8 rounded-full bg-white text-[#012E26] hover:bg-[#00BFA5] hover:text-white transition-all duration-300 font-medium shadow-md border border-[#00BFA5]"
                    >
                        View More
                    </a>
                </div>
            </div>
        </div>-->

        <div id="gallery">
            <div class="container-fluid mb-10">
                <div class="flex flex-col md:flex-row">
                    <div class="w-full md:w-3/5 md:pr-4 mb-4 md:mb-0">
                        <img src="assets/img/academic-blocks/block-c.jpg" alt="Image 1"
                             class="w-full h-[500px] shadow-lg">
                    </div>
                    <div class="w-full md:w-2/5 md:pl-4">
                        <iframe class="w-full h-[500px] object-cover shadow-lg"
                                src="https://www.youtube.com/embed/RSa3v7KV2h4?si=qWzM2swYFmjZ0Sgm"
                                title="YouTube video player" frameborder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </div>
                </div>
            </div>
        </div>
        <div id="recruiters" class="w-full">
            <div class="bg-blue-100 text-center font-sans py-12">
                <h2 class="text-xl md:text-2xl font-bold mb-4">Recruiters</h2>
                <div class="flex items-center justify-center gap-6 py-4">
                    <button class="bg-white p-2 md:p-3 rounded-full shadow-md flex items-center justify-center"
                            (click)="prevSlide()">&#10094;
                    </button>
                    <div class="overflow-hidden w-[85%] sm:w-[90%] md:w-[80%] lg:w-[70%] flex items-center">
                        <div class="flex gap-3 sm:gap-4 transition-transform duration-500 ease-in-out self-center"
                             [style.transform]="'translateX(-' + (index * 120) + 'px)'">
                            <div *ngFor="let recruiter of recruiters"
                                 class="min-w-[100px] sm:min-w-[120px] p-2 sm:p-3 bg-white shadow-md rounded flex items-center justify-center">
                                <img [src]="recruiter.logo" [alt]="recruiter.name"
                                     class="max-w-[80px] sm:max-w-[100px] h-auto">
                            </div>
                        </div>
                    </div>
                    <button class="bg-white p-2 md:p-3 rounded-full shadow-md flex items-center justify-center"
                            (click)="nextSlide()">&#10095;
                    </button>
                </div>
                <!--                <button class="mt-4 bg-blue-500 text-white px-4 sm:px-6 py-2 rounded-full">View all</button>-->
            </div>
        </div>
    </div>
</section>
